import React from 'react';
import { FormControl } from 'react-bootstrap';
import { Typography } from 'Components/atoms';
import { CustomActionDto } from '@ampsec/platform-client';
import { ACTION_LABELS, SUPPORTING_TEXT } from 'Core-utils/constants/constants';
import {
    AmplifierTrainingTemplateDefinition,
    AmplifierTrainingTemplateKey,
    getAmplifierTrainingTemplateByKey,
} from './amplifierTrainingTemplates';

interface AmplifierTrainingGeneralStepProps {
    templateKey: AmplifierTrainingTemplateKey;
    templates: AmplifierTrainingTemplateDefinition[];
    formData: CustomActionDto;
    handleFieldChange: (id: string, value: string) => void;
    errors: string[];
}

const renderError = (error: string) => (
    <Typography variant="caption4" color="vizualization-red-200">
        {error} {SUPPORTING_TEXT}
    </Typography>
);

export const AmplifierTrainingGeneralStep: React.FC<AmplifierTrainingGeneralStepProps> = ({
    templateKey,
    templates,
    formData,
    handleFieldChange,
    errors,
}) => {
    const template = getAmplifierTrainingTemplateByKey(templateKey, templates);

    return (
        <div className="action-block d-flex flex-column gap-3">
            <div className="d-flex flex-column gap-1">
                <Typography variant="subtitle2" color="text-high-emphasis">
                    {template?.title}
                </Typography>
                <Typography variant="body3" color="text-medium-emphasis">
                    {template?.description}
                </Typography>
            </div>

            <div className="d-flex flex-column gap-2">
                <Typography variant="body3" color="text-medium-emphasis">
                    {ACTION_LABELS[2]}
                </Typography>
                <FormControl
                    value={formData.displayValue ?? ''}
                    className="input-field__input bg-transparent"
                    onChange={(event) => handleFieldChange('displayValue', event.target.value)}
                    placeholder={template?.actionNamePlaceholder}
                    maxLength={50}
                />
                <Typography variant="caption1" color="text-low-emphasis">
                    {template?.actionNameHelper}
                </Typography>
                {errors.includes(`${ACTION_LABELS[2]} ${SUPPORTING_TEXT}`) && renderError(`${ACTION_LABELS[2]}`)}
            </div>

            <div className="d-flex flex-column gap-2">
                <Typography variant="body3" color="text-medium-emphasis">
                    {ACTION_LABELS[5]}
                </Typography>
                <FormControl
                    as="textarea"
                    rows={3}
                    value={formData.description ?? ''}
                    className="input-field__input bg-transparent"
                    onChange={(event) => handleFieldChange('description', event.target.value)}
                    placeholder={template?.descriptionPlaceholder}
                    maxLength={200}
                />
            </div>
        </div>
    );
};
